import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import classNames from 'classnames/bind';
import omit from 'lodash/omit';
import cmComponentsForHome from '../../CoreMedia/components/forHome';
import cmComponentsForMarketing from '../../CoreMedia/components/forMarketing';
import cmComponentsForDepartment from '../../CoreMedia/components/forDepartment';
import cmComponentsForCoupon from '../../CoreMedia/components/forCoupon';
import * as styles from '../IrisPage/IrisPage.css';
import withReducerSaga from '../../hoc/ReducerRegistry/withReducerSaga';
import CMPageReducer from '../../reducers/CMPageReducer';
import CMPageSaga from '../../sagas/CMPageSaga';
import CMPageAction from '../../actions/CMPageAction';
import {
    selectShouldRender,
    selectPreferences,
    selectFeatureFlags,
    selectDeviceType,
    selectRequestUrl,
    selectIsNative,
    // isPreview,
} from '../../selectors/ContextSelector';
import {
    selectCMPageData,
    selectCMSeoMeta,
    selectCMBreadCrumbData,
    selectHostName,
    selectIrisS1Targeter,
} from '../../selectors/CMPageSelector';
import defaultWrapperRenderer from './defaultWrapperRenderer';
import renderCurrentComponent from './renderCurrentComponent';
import irisdefaultWrapperRenderer from '../IrisPage/defaultWrapperRenderer';
import irisRenderCurrentComponent from '../IrisPage/renderCurrentComponent';
import generateComponentKeyString from './generateComponentKeyString';
import { RECOMMENDATION_SOURCE_TYPE_SOURCE } from '../../common/Constants';

const cx = classNames.bind(styles);
const gridcomponent = 'gridcomponent';

/** Zone render allows us to override or customize the component rendering in given zone * */
const findZoneRenderer = (zoneRenderers, zone) => {
    if (!zoneRenderers || !zone || !Array.isArray(zoneRenderers)) return false;

    const zoneRenderer = zoneRenderers?.find((render) => {
        if (render?.zone === zone) return true;
        return null;
    });
    const renderer = get(zoneRenderer, 'renderer', false);

    return renderer || false;
};

const filterComponents = (cmpRenderers, cmp) => {
    if (!cmpRenderers || !cmp || !Array.isArray(cmpRenderers)) return false;

    return cmpRenderers?.includes(cmp);
};
let cmCompleteComponentList = {};

const defaultRowClass = cx('row', 'col-12');

const cmColClassName = 'col';
const linkfarmClass = 'linkfarm';
let cmComponentsWithoutGrid = {};

const getCMComponents = (pageType) => {
    switch (pageType) {
        case 'HOME':
            return cmComponentsForHome;
        case 'MARKETING':
            return cmComponentsForMarketing;
        case 'DEPARTMENT':
            return cmComponentsForDepartment;
        case 'COUPONS':
            return cmComponentsForCoupon;
        default:
            return {};
    }
};
const CMPage = (props) => {
    const {
        limitInitialComponentsRendered,
        pageType,
        doNotRender,
        params,
        offset,
        height,
        irisComponentsData,
        irisS1Enable,
        theme,
        currentURL,
        location,
        history,
        redirectAction,
        enableCanonicalFallback,
        cmFallbackEnabled,
        isCMPageEnabled,
        aggregateAPI,
        cmClientCall,
        cmFallbackPreferences,
        departmentLowerZoneSm,
        handleDepartmentPage2ColCallback,
        title,
    } = props;

    const [mounted, setMounted] = useState(false);

    const [isLHN, setIsLHN] = useState(false);

    const seoMetaData = useSelector((state) => selectCMSeoMeta(state));
    const isNative = useSelector((state) => selectIsNative(state));
    const breadCrumbData = useSelector((state) => selectCMBreadCrumbData(state));
    const reqPagePath = useSelector((state) => selectRequestUrl(state));
    const hostName = useSelector((state) => selectHostName(state));
    const coreMediaData = useSelector((state) => selectCMPageData(state));
    const shouldRender = useSelector((state) => selectShouldRender(state));
    const featureFlags = useSelector((state) => selectFeatureFlags(state));
    const preferences = useSelector((state) => selectPreferences(state));
    const deviceType = useSelector((state) => selectDeviceType(state));
    const iRisS1Targeter = useSelector((state) => selectIrisS1Targeter(state));
    const isPreview = true;
    const cmComponents = getCMComponents(pageType);
    const extraRowsNeeded = useRef(true);
    const dept2ColLayoutRef = useRef(false);

    if (!mounted) {
        // Code for componentWillMount here
        // This code is called only one time before intial render

        if (!doNotRender) {
            cmCompleteComponentList = {
                ...cmComponents,
                ...props?.cmPageSpecificComponents,
            };
            cmComponentsWithoutGrid = omit(cmCompleteComponentList, [gridcomponent]);
            if (isEmpty(coreMediaData) && cmClientCall) {
                props?.actions?.getCMPageTemplateData(
                    params,
                    aggregateAPI,
                    cmFallbackEnabled,
                    cmFallbackPreferences,
                    redirectAction,
                    location,
                    history
                );
            }
        }
    }
    useEffect(() => {
        setMounted(true);
    }, []);
    const parseOneRow = (rowData, index, isReczone) => {
        let retOneRow = null;
        // TODO: Refactor
        // props.tag or props.rowTag?
        const Tag = props?.tag;
        const templateLocal = rowData?.template || defaultRowClass;
        if (rowData?.placements?.length) {
            const deptLayout2Col =
                pageType === 'DEPARTMENT' &&
                rowData?.placements?.length === 2 &&
                rowData?.placements[0]?.name === 'LHN' &&
                !isEmpty(rowData?.placements[0]?.items) &&
                rowData?.placements[1]?.name === 'S2';

            dept2ColLayoutRef.current = deptLayout2Col;

            if (rowData?.placements[0]?.name === 'LHN' && !isLHN) {
                setIsLHN(true);
            }

            // only set once if deptLayout2Col is true
            if (extraRowsNeeded?.current && extraRowsNeeded?.current !== !deptLayout2Col)
                extraRowsNeeded.current = !deptLayout2Col;

            // check if template name is part of zone renderers
            const zoneRendererForDept = findZoneRenderer(props?.zoneRenderer, 'flex-two-cols');
            // if zonerender found, call zone render instead for rowData
            const parsedRowData =
                zoneRendererForDept && deptLayout2Col
                    ? zoneRendererForDept(rowData, rowData?.placements)
                    : rowData;

            const key = parsedRowData?.placements?.map((placement) => placement?.name).join(',');
            retOneRow = (
                <Tag
                    className={cx(templateLocal, {
                        'lhn-s2': deptLayout2Col,
                        deptDynamicLayout: dept2ColLayoutRef?.current,
                    })}
                    key={key}
                >
                    {oneRowGen(parsedRowData, isReczone)}
                </Tag>
            );
        } else {
            /* istanbul ignore next */
            console.warn('CM: placements not found in response');
        }
        return retOneRow;
    };

    const renderComponents = (oneCol, isReczone) => {
        const propsData = {
            preferences,
            featureFlags,
            deviceType,
            pageType,
            isPreview,
            offset,
            height,
            isLHN,
        };
        let sourceUrlFound = null;
        if (!isEmpty(params)) {
            const sourceUrl = params;
            const splitUrl = sourceUrl.split('&');
            sourceUrlFound =
                splitUrl &&
                splitUrl.find((element) => element.includes(RECOMMENDATION_SOURCE_TYPE_SOURCE));
        }
        const colDom = [];
        /* istanbul ignore else */
        // in case of zoneRenderer though components length is 0 but we are still pushing some components
        if (oneCol?.items && (oneCol?.items?.length || props?.zoneRenderer)) {
            // Page can supply the wrapper html if they need to render
            const wrapperRenderer = props?.colWrapperRenderer;
            const zoneRenderer = findZoneRenderer(props?.zoneRenderer, oneCol?.name);
            // if zonerender found, collate all the component and call zone render instead
            /* istanbul ignore else */
            if (zoneRenderer) {
                const renderedZoneComponents = zoneRenderer(
                    oneCol?.name,
                    oneCol?.items,
                    cmCompleteComponentList,
                    cmComponentsWithoutGrid,
                    propsData
                );
                renderedZoneComponents.forEach((renderedComponent) =>
                    colDom.push(renderedComponent)
                );
            } else if (
                oneCol.name === 'S1' &&
                !__SERVER__ &&
                irisS1Enable &&
                isEmpty(oneCol?.items)
            ) {
                const irisComponentsWithoutGrid = omit(irisComponentsData, [gridcomponent]);
                iRisS1Targeter?.forEach((component, index) => {
                    const filterCmp = filterComponents(
                        ['JCPRecoZone', 'JCPAds'],
                        component?.componentType
                    );
                    if (!filterCmp && !isReczone) {
                        const item = irisdefaultWrapperRenderer(
                            irisRenderCurrentComponent(
                                component,
                                index,
                                irisComponentsData,
                                irisComponentsWithoutGrid,
                                propsData,
                                limitInitialComponentsRendered
                            ),
                            generateComponentKeyString(component?.componentType, index)
                        );
                        colDom.push(item);
                    } else if (
                        filterCmp &&
                        isReczone === 'JCPRecoZone' &&
                        component?.componentType === isReczone
                    ) {
                        const recProps = {
                            strategy: component?.content?.strategy,
                            style: component?.content?.style,
                        };
                        const item = addRecZone(recProps);
                        colDom.push(item);
                    } else if (
                        filterCmp &&
                        isReczone === 'JCPAds' &&
                        component?.componentType === isReczone
                    ) {
                        const item = addAds(component);
                        colDom.push(item);
                    }
                });
            } else {
                oneCol?.items?.forEach((component, index) => {
                    const filterCmp = filterComponents(
                        ['JCPRecoZone', 'JCPAds', 'JCPSeoBlock'],
                        component?.componentType
                    );
                    if (!filterCmp && (!isReczone || dept2ColLayoutRef?.current)) {
                        const item = wrapperRenderer(
                            renderCurrentComponent(
                                component,
                                index,
                                cmCompleteComponentList,
                                cmComponentsWithoutGrid,
                                propsData,
                                limitInitialComponentsRendered
                            ),
                            generateComponentKeyString(component?.componentType, index)
                        );
                        colDom.push(item);
                    } else if (
                        filterCmp &&
                        ((isReczone === 'JCPRecoZone' && component?.componentType === isReczone) ||
                            (dept2ColLayoutRef?.current &&
                                component?.componentType === 'JCPRecoZone'))
                    ) {
                        const recProps = {
                            strategy: component?.content?.strategy,
                            style: component?.content?.style,
                        };
                        const item = addRecZone(recProps);
                        colDom.push(item);
                    } else if (
                        filterCmp &&
                        ((isReczone === 'JCPAds' && component?.componentType === isReczone) ||
                            (dept2ColLayoutRef?.current && component?.componentType === 'JCPAds'))
                    ) {
                        const item = addAds(component);
                        colDom.push(item);
                    } else if (filterCmp && component?.componentType === 'JCPSeoBlock') {
                        const item = addSeoCopyBlock(false);
                        colDom.push(item);
                    }
                });
            }
        } else {
            console.warn('CM: components is missing in response');
        }
        return sourceUrlFound ? !__SERVER__ && colDom : colDom;
    };

    const checkLinkFarmAvailableinS2 = (cmRowData = null) => {
        // Only check S2 for Linkfarm data is available
        let isPlacementDataEmpty = false;
        if (cmRowData?.items?.length > 0) {
            cmRowData.items.forEach((lkfrmDt) => {
                if (lkfrmDt.componentType === 'LinkFarm') {
                    isPlacementDataEmpty = true;
                }
            });
        }
        return isPlacementDataEmpty;
    };

    const oneRowGen = (rowData, isReczone) => {
        const fullColumn = [];
        const isPlacementDataEmpty = coreMediaData?.grid?.rows
            ?.map((placements) => {
                return placements?.placements[0];
            })
            ?.filter((placement) => placement?.name === 'S1')
            ?.every((placement) => placement?.items?.length === 0);
        // TODO: Refactor: Should we use lodash to keep the code cleaner
        /* istanbul ignore else */
        if (rowData?.placements?.length) {
            rowData?.placements?.forEach((oneCol, index) => {
                fullColumn.push(
                    <div
                        key={oneCol?.name || index}
                        className={cx(
                            cmColClassName,
                            oneCol?.name,
                            oneCol?.name === 'S2' && checkLinkFarmAvailableinS2(oneCol)
                                ? 's2linkfarm'
                                : '',
                            oneCol?.name === 'S2' && !isPlacementDataEmpty ? linkfarmClass : '',
                            {
                                departmentLowerZoneSm:
                                    oneCol?.name === 'S2-b' && departmentLowerZoneSm,
                            }
                        )}
                        data-automation-id={`zone-${oneCol?.name}`}
                        ref={handleDepartmentPage2ColCallback}
                    >
                        {renderComponents(oneCol, isReczone)}
                    </div>
                );
            });
        } else {
            console.warn('CM: placements not found in response');
        }
        return fullColumn;
    };

    const parseRow = (isReczone) => {
        const rootNode = coreMediaData?.grid;
        const fullNode = [];
        if (rootNode && !isEmpty(rootNode?.rows)) {
            rootNode?.rows?.forEach((oneRowData, index) => {
                fullNode.push(parseOneRow(oneRowData, index, isReczone));
            });
        } else {
            console.warn('CM: rows not found in response');
        }

        if (isReczone) {
            const newFullNodesWithChildren = fullNode?.filter((placement, index) =>
                placement?.props?.children?.some((child) => {
                    // debugger;
                    return (
                        child?.props?.children?.props?.children?.length > 0 ||
                        child?.props?.children?.length > 0
                    );
                })
            );

            return newFullNodesWithChildren;
        }
        return fullNode;
    };

    const addSeoMetaTag = () => {
        const seoContent = seoMetaData || {};
        const MetaTag = cmCompleteComponentList?.seotag?.component;
        /* istanbul ignore next */
        let seoComponent = null;

        try {
            seoComponent = (
                <MetaTag
                    data-automation-id="seoContent"
                    seoBlock={seoContent}
                    preferences={preferences}
                    deviceType={deviceType}
                    canonicalURL={currentURL}
                    hostname={hostName}
                    location={location}
                    enableCanonicalFallback={enableCanonicalFallback}
                />
            );
        } catch (e) {
            /* istanbul ignore next */
            console.warn('CM: seo meta tag not loaded, check api response');
        }

        return seoComponent;
    };

    const addSeoCopyBlock = (isOwnSection = true) => {
        const SeoCopyBlockContent = seoMetaData?.onPageCopy || {};
        const SeoCopyBlock = cmCompleteComponentList?.seoblock?.component;

        let SeoCopyBlockComponent = null;

        if (seoMetaData?.onPageCopy) {
            try {
                SeoCopyBlockComponent = isOwnSection ? (
                    <div className={defaultRowClass}>
                        <div className={cx(cmColClassName)} data-automation-id="zone-seo-block">
                            <div className={cx('regularWidthComp', 'seoblock')}>
                                <SeoCopyBlock
                                    automationId="SeoCopyBlockComponent"
                                    html={SeoCopyBlockContent}
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div
                        className={cx('regularWidthComp', 'seoblock')}
                        data-automation-id="zone-seo-block"
                    >
                        <SeoCopyBlock
                            automationId="SeoCopyBlockComponent"
                            html={SeoCopyBlockContent}
                        />
                    </div>
                );
            } catch (e) {
                /* istanbul ignore next */
                console.warn('CM: SeoCopyBlockComponent not loaded, check api response');
            }
        }

        return SeoCopyBlockComponent;
    };

    /* istanbul ignore next */
    const addAds = (compData) => {
        const AdsCmp = cmCompleteComponentList?.jcpads?.component;
        let adsContent = null;
        try {
            adsContent = AdsCmp ? (
                <div className={cx('regularWidthComp', 'cmjcpads')}>
                    <AdsCmp adId={compData?.content?.adId} automationId="JCPAds" />
                </div>
            ) : null;
        } catch (e) {
            /* istanbul ignore next */
            console.warn('CM: jcpads not loaded');
        }
        return adsContent;
    };

    const addBreadCrumbsNav = () => {
        const BreadCrumbNav = cmCompleteComponentList?.breadcrumbs?.component;
        let breadCrumbNavComponent = null;
        try {
            breadCrumbNavComponent = BreadCrumbNav ? (
                <div className={`${defaultRowClass} ${cx('bottomMarginSeoBreadCrumb')}`}>
                    <div className={cx(cmColClassName)}>
                        <BreadCrumbNav
                            automationId="BreadCrumbNav"
                            breadCrumbs={breadCrumbData}
                            reqPagePath={reqPagePath}
                            hostName={hostName}
                            isCMPageEnabled={isCMPageEnabled}
                            title={title}
                        />
                    </div>
                </div>
            ) : null;
        } catch (e) {
            /* istanbul ignore next */
            console.warn('CM: bread crumb not loaded, check api response');
        }

        return breadCrumbNavComponent;
    };

    /* istanbul ignore next */
    const addRecZone = (recProps) => {
        const RecZoneCmp = cmCompleteComponentList?.jcprecozone?.component;
        let recZoneContent = null;
        const deptId = breadCrumbData?.filter((bdrDpt) => bdrDpt?.deptId); // get deptId from breadcrumb data for department page
        try {
            recZoneContent = RecZoneCmp ? (
                <div className={cx('regularWidthComp', 'reczones')}>
                    <div className={cx(cmColClassName)}>
                        <RecZoneCmp
                            strategy={recProps?.strategy}
                            style={recProps?.style}
                            pageType={pageType}
                            deviceType={deviceType}
                            departmentid={deptId?.[0]?.deptId || ''}
                        />
                    </div>
                </div>
            ) : null;
        } catch (e) {
            console.warn('CM: rec zone not loaded, check api response');
        }
        return recZoneContent;
    };

    const shouldRenderFun = () => {
        return shouldRender ? (
            <div id="containerWidthCm" className={cx(styles?.containerWidth, theme)}>
                {/* <LoadSVG svgPaths={[coreSprite, siteSprite]} /> */}
                {addSeoMetaTag()}
                {!isNative && addBreadCrumbsNav()}
                {parseRow()}
                {extraRowsNeeded?.current && parseRow('JCPRecoZone')}
                {extraRowsNeeded?.current && addSeoCopyBlock()}
                {extraRowsNeeded?.current && parseRow('JCPAds')}
            </div>
        ) : null;
    };

    return doNotRender ? <></> : shouldRenderFun();
};
CMPage.propTypes = {
    coreMediaData: PropTypes.object,
    tag: PropTypes.string,
    preferences: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    deviceType: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    featureFlags: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    params: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    actions: PropTypes.objectOf(PropTypes.func),
    cmComponents: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    cmFallbackEnabled: PropTypes.bool,
    cmFallbackPreferences: PropTypes.object,
    cmPageSpecificComponents: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    currentURL: PropTypes.string,
    aggregateAPI: PropTypes.bool,
    colWrapperRenderer: PropTypes.func,
    redirectAction: PropTypes.func,
    shouldRender: PropTypes.bool,
    doNotRender: PropTypes.bool,
    zoneRenderer: PropTypes.array,
    seoMetaData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    theme: PropTypes.string,
    cmClientCall: PropTypes.bool,
    pageType: PropTypes.bool,
    isPreview: PropTypes.bool,
    location: PropTypes.object,
    history: PropTypes.object,
    limitInitialComponentsRendered: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
    // when using react rendering stretigies use this props to pass height and offset to ref div
    offset: PropTypes.number,
    height: PropTypes.number,
    enableCanonicalFallback: PropTypes.bool,
    irisS1Enable: PropTypes.bool,
    isCMPageEnabled: PropTypes.bool,
    irisComponentsData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    departmentLowerZoneSm: PropTypes.bool,
    handleDepartmentPage2ColCallback: PropTypes.func,
    title: PropTypes.bool,
};
CMPage.defaultProps = {
    coreMediaData: {},
    tag: 'div',
    params: {},
    actions: {},
    pageType: '',
    preferences: {},
    deviceType: {},
    featureFlags: {},
    cmComponents: {},
    cmFallbackEnabled: false,
    cmFallbackPreferences: {},
    cmPageSpecificComponents: {},
    currentURL: '',
    aggregateAPI: false,
    colWrapperRenderer: defaultWrapperRenderer,
    redirectAction: undefined,
    shouldRender: true,
    zoneRenderer: [],
    seoMetaData: {},
    theme: '',
    cmClientCall: true,
    isPreview: false,
    doNotRender: false,
    location: {},
    history: {},
    limitInitialComponentsRendered: null,
    height: 100,
    offset: 300,
    enableCanonicalFallback: false,
    irisS1Enable: false,
    isCMPageEnabled: false,
    irisComponentsData: {},
    departmentLowerZoneSm: false,
    handleDepartmentPage2ColCallback: () => null,
    title: '',
};
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(CMPageAction, dispatch),
});

export default withReducerSaga(
    [CMPageReducer],
    [CMPageSaga]
)(connect(null, mapDispatchToProps)(CMPage));
